import React, { useEffect, useState } from 'react';
import back from "../../../assets/img/npBookingWindowAssets/backArrow.svg";
import { useNavigate } from 'react-router-dom';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import axios from 'axios';
import AnalyticsTable from '../../AllComponents/AnalyticsTable';

const ClaimReworks = () => {
  const navigate = useNavigate();
  const [reworks, setReworks] = useState(true);
  const [revenue, setRevenue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [claimData, setClaimData] = useState([]);
  const [responseData, setResponseData] = useState({});
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const getClaimData = async () => {
      const { data } = await axios.get('http://localhost:8081/api/dashboard/operations/comparative-analytics/claim-reworks');
      setLoading(true);
      setResponseData(data);
      setClaimData(data.result);
      setChartData(data.overallData);
      setLoading(false);
    }
    getClaimData();
  }, [])

  const CustomizedXAxisTick = ({ x, y, payload }) => {
    const lines = payload.value.split(' ');
    return (
      <g transform={`translate(${x},${y})`}>
        {lines.map((line, index) => (
          <text key={index} x={0} y={index * 13} textAnchor="middle" fill="#989899" fontSize={8}>
            {line}
          </text>
        ))}
      </g>
    );
  };

  return (
    <div className='bg-doc-bg fixed w-full h-screen top-0 left-0'>
      <div className='z-20'>
        <div className="flex justify-between px-4 pb-4 pt-14">
          <div className="cursor-pointer" onClick={() => navigate('/dashboard')}><img src={back} alt="back" /></div>
          <div className="text-[#FFFFFF] text-base font-display-medium">Claim Reworks</div>
          <div></div>
        </div>

        <div className="bg-white rounded-t-[26px] px-4">
          <div className="grid grid-cols-2 gap-3 py-4">
            <button className={`rounded-[12px] font-display-regular text-sm py-2 ${reworks ? 'bg-[#8DC63F] text-white' : 'text-lite-black bg-[#EFEDED]'}`} onClick={() => { setReworks(true); setRevenue(false) }}>Percentage of Reworks</button>
            <button className={`rounded-[12px] font-display-regular text-sm py-2 ${revenue ? 'bg-[#8DC63F] text-white' : 'text-lite-black bg-[#EFEDED]'}`} onClick={() => { setRevenue(true); setReworks(false) }}>Revenue at Risk</button>
          </div>
        </div>

        <div className='bg-white pb-3 cursor-pointer'>
          <div className='p-2'>
            <div style={{ height: "200px", width: '100%' }}>
              <ResponsiveContainer>
                <AreaChart
                  data={chartData}
                  margin={{
                    top: 5,
                    right: 5,
                    left: -25,
                    bottom: 0,
                  }}
                >
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#34B5FE" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#34B5FE" stopOpacity={0.1} />
                    </linearGradient>
                    <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#FF9300" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#FF9300" stopOpacity={0.1} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid horizontal={false} stroke="#98989866" strokeWidth={0.4} />
                  <XAxis axisLine={false} tickLine={false} interval={0} dataKey="name" tick={<CustomizedXAxisTick />} tickMargin={7} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 9 }} type="number" domain={[0, 'auto']} allowDataOverflow={true} tickMargin={5} />
                  <Tooltip />
                  <Area type="monotone" dataKey="myData" stroke="#34B5FE" fillOpacity={1} fill="url(#colorUv)" dot={{ stroke: '#FFFFFF', strokeWidth: 1, fill: '#34B5FE', r: 4 }} />
                  <Area type="monotone" dataKey="platformAvg" stroke="#989899" fillOpacity={1} fill="url(#colorPv)" dot={{ stroke: '#FFFFFF', strokeWidth: 1, fill: '#FF9300', r: 4 }} />
                </AreaChart>
              </ResponsiveContainer>
            </div>

            <div className='flex justify-between px-6 mt-2 pb-5 font-display-regular text-lite-black text-[0.625rem]'>
              <p className='ms-4'>Month</p>
              <div className='flex items-center gap-1 ms-10'>
                <div className='rounded-full bg-[#34B5FE] w-2 h-2'></div>
                <p>My Data</p>
              </div>
              <div className='flex items-center gap-1 justify-end'>
                <div className='rounded-full bg-[#FF9300] w-2 h-2'></div>
                <p>Platform Avg</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='bg-white absolute w-full top-[25rem] bottom-0 no-scrollbar overflow-y-scroll px-4 font-display-regular text-[0.75rem]'>
        {loading ? <div className="flex justify-center mt-48">
          <div role="status">
            <svg aria-hidden="true" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-[#1B453E]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        </div> :
          <div>
            <AnalyticsTable tableData={claimData} />
            <AnalyticsTable avg={true} npsDataOverallAvg={responseData.npsDataOverallAvg} platformDataOverallAvg={responseData.platformDataOverallAvg} />
          </div>
        }
      </div>
    </div>
  )
}

export default ClaimReworks
